<template>
  <div id="printtest"></div>
  <Transition>
    <div v-if="showActions" ref="modalbg" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 text-center lg:px-20 lg:py-10" @click="checkClick($event)">
      <div class="bg-white w-full lg:w-2/3 inline-block lg:rounded-3xl overflow-y-auto lg:px-8 pt-4 basis-0 relative text-center">
        <div class="text-center w-full border-b-4 border-black p-2">
          <button type="button" class="admin-button--ghost admin-button--icon absolute top-2 right-10" aria-label="Schließen" @click="showActions = false">
            <i ref="xmark" class="fa fa-xmark text-4xl"></i>
          </button>
          <span class="mt-10 font-bold text-3xl text-black">Aktionen</span>
        </div>
        <div class="flex flex-col items-center gap-2 py-3">
          <button v-if="jobs.length > 0 && billingMode" class="admin-button--secondary" @click="printPage()">
            Drucken
          </button>
          <button v-if="stats.permissions.admin" class="admin-button--danger" @click="requestSMS('confirm')">
            Bestätigung anfordern (SMS)
          </button>
          <button v-if="stats.permissions.admin" class="admin-button--danger" @click="requestSMS('accept')">
            Annahme anfordern (SMS)
          </button>
        </div>
      </div>
    </div>
  </Transition>
  <Transition>
    <TopBanner :mode="bannerMode" :text="bannerText" v-if="bannerText" />
  </Transition>
  <Spinner v-if="loading" />
  <div class="admin-page admin-page--centered relative" @click="checkClick($event)">
    <Transition>
      <JobModal v-if="selectedJob" :job="selectedJob" @close="selectedJob = false" :users="allUsers" @changeUser="changeUser" />
    </Transition>
    <Transition>
      <ContactDetails v-if="contactDetails" :token="token" :job="contactDetails" @close="contactDetails = false" />
    </Transition>
    <div class="relative w-full text-center print:text-xxs">
      <div class="admin-page-inner relative text-center">
        <div class="admin-page-header">
          <div class="admin-page-heading">
            <h1 v-if="!billingMode" class="admin-page-title">Auftragsübersicht</h1>
            <h1 v-else class="admin-page-title">Abrechnungsansicht</h1>
          </div>
          <div class="print:hidden">
            <div class="admin-action-bar">
              <button v-if="meta.results > 0" class="admin-button--secondary lg:hidden" @click="showActions = true">
                Aktionen
              </button>
              <button class="admin-button--secondary hidden lg:inline-block 2xl:hidden" @click="showActions = true">
                Aktionen
              </button>
              <button v-if="jobs.length > 0 && billingMode" class="admin-button--secondary hidden 2xl:inline-block" onclick="print()">
                Drucken
              </button>
              <button v-if="stats.permissions.admin" class="admin-button--danger hidden 2xl:inline-block" @click="requestSMS('confirm')">
                Bestätigung anfordern (SMS)
              </button>
              <button v-if="stats.permissions.admin" class="admin-button--danger hidden 2xl:inline-block" @click="requestSMS('accept')">
                Annahme anfordern (SMS)
              </button>
            </div>
          </div>
        </div>
        <div class="print:hidden">
          <div class="admin-tabs">
            <button class="admin-tab" :class="{ 'admin-tab--active': !billingMode }" @click="billingMode && toggleBillingMode()">
              Auftragsübersicht
            </button>
            <button class="admin-tab" :class="{ 'admin-tab--active': billingMode }" @click="!billingMode && toggleBillingMode()">
              Abrechnungsansicht
            </button>
          </div>
        </div>
        <section class="admin-panel mt-5 w-full sm:w-5/6 inline-block text-left">
          <div class="admin-panel__body">
          <span class="block text-2xl font-bold">Filter</span>
          <div class="inline-block relative">
            <span class="block font-bold mt-2">Projekt</span>
            <div class="absolute right-4 text-2xl bottom-3 text-gray-500 cursor-pointer" @click="filter.project = ''">
              <i class="fa fa-xmark" />
            </div>
            <input size="1" v-model="filter.project" placeholder="Projektname" @click="filterProjects" @focus="filterProjects" class="mr-2 border-b-2 w-64 sm:w-96 p-2 border-gray-500" @input="filterProjects" @keydown.enter.prevent="getJobs()" />
            <div v-if="showProjectDropdown" ref="projectList" class="border-gray-500 absolute p-2 w-full bg-white max-h-96 overflow-y-auto"></div>
          </div>
          <div class="inline-block">
            <div class="inline-block acwrapper">
              <span class="block font-bold mt-2">Startdatum ab</span>
              <input size="1" type="date" v-model="filter.start" class="mr-2 border-b-2 w-36 border-gray-500" @keydown.enter.prevent="getJobs()" />
            </div>
            <div class="inline-block">
              <span class="block font-bold mt-2">Startdatum bis</span>
              <input size="1" type="date" v-model="filter.end" class="mr-2 border-b-2 w-36 border-gray-500" @keydown.enter.prevent="getJobs()" />
            </div>
          </div>
          <!-- Dependent dropdown: Einsatzort -> Einsatzstelle (filter column B depending on value in column A) -->
          <div class="inline-block ml-2">
            <div class="inline-block">
              <span class="block font-bold mt-2">Einsatzort</span>
              <select v-model="filter.location" @change="onEinsatzortChange" @keydown.enter.prevent="getJobs()" class="mr-2 border-b-2 w-48 p-1 border-gray-500 bg-white">
                <option value="">Alle</option>
                <option v-for="loc in availableLocations" :key="loc" :value="loc">{{ loc }}</option>
              </select>
            </div>
            <div class="inline-block">
              <span class="block font-bold mt-2">Einsatzstelle</span>
              <select v-model="filter.place" :disabled="!filter.location" @keydown.enter.prevent="getJobs()" class="mr-2 border-b-2 w-48 p-1 border-gray-500 bg-white">
                <option value="">Alle</option>
                <option v-for="place in availablePlaces" :key="place" :value="place">{{ place }}</option>
              </select>
            </div>
          </div>
          <button class="admin-button--secondary mx-1 mt-2" @click="getJobs()">Suchen</button>
          <button class="admin-button--secondary mx-1 mt-2" @click="getJobs(true)">Zusammenfassung</button>
          <button class="admin-button--secondary mx-1 mt-2" @click="resetFilter()">Filter zurücksetzen</button>
          <div v-if="meta.results > 999"><span class="text-red-500 font-bold font-xl pt-3">Maximale Anzahl an Ergebnisse erreicht. Bitte Ergebnis durch Filter weiter eingrenzen!</span></div>
          </div>
        </section>
        <div v-if="searched" class="text-left mt-5">
          <span class="font-bold">Aufträge gefunden: {{ meta.results }}</span><span class="font-bold"> | Summe
            Soll-Stunden: {{ meta.sumSollStunden }}</span><span class="font-bold"> | Summe
              Ist-Stunden: {{ meta.sumIstStunden }}</span><span class="font-bold"> | Summe
                geprüfter Ist-Stunden: {{ meta.sumBillableHours }}</span><span class="font-bold"> | Summe Strafen: {{
            meta.sumPenalties }}
            €</span>
        </div>
        <div class="mt-3 px-4">
          <span class="text-sm text-gray-500">
            <i class="fa fa-info-circle mr-1"></i>
            Shift+Klick auf eine Zelle kopiert den Wert in die Zwischenablage. Eingebaute Spalten-Filter über die Trichter-Icons in den Spaltenüberschriften.
          </span>
        </div>
        <div class="flex justify-end gap-2 mt-3 print:hidden">
          <JssColumnManager :columns="columnManagerColumns" :order="columnOrder" :hidden="columnHidden"
            @change="onColumnsChange" />
          <button v-if="jobs.length > 0" class="admin-button--secondary" @click="exportView()">
            <i class="fa fa-file-excel mr-1"></i>Excel Export
          </button>
        </div>
        <div ref="spreadsheetContainer" class="jss-container rounded-lg shadow-lg mt-2 w-full print:hidden"></div>
      </div>
    </div>
  </div>
</template>

<script>
import CASP from "../../CASP";
import { useCookies } from "vue3-cookies";
import JobModal from "@/components/JobModal.vue";
import ContactDetails from "@/components/ContactDetails.vue";
import Spinner from "@/components/Spinner";
import TopBanner from "@/components/TopBanner";
import jspreadsheet from "jspreadsheet-ce";
import "jspreadsheet-ce/dist/jspreadsheet.css";
import "jsuites/dist/jsuites.css";
import JssColumnManager from "@/components/JssColumnManager.vue";
import { exportJssView } from "@/lib/jssExport";
import { applyColumnSettings, installAutocompleteFilters, removeAutocompleteFilters, stickFilterRow } from "@/lib/jssColumns";
import { createRowHighlighter } from "@/lib/jssRowHighlight";
import { installAppendOnlyRowLoading } from "@/lib/jssAppendOnlyRows";
import { sortJssRows } from "@/lib/jssSort";

let in3Days = new Date();
in3Days.setDate(in3Days.getDate() + 3);

// ─── Column definitions ──────────────────────────────────────────────
// Non-billing mode (Auftragsübersicht)
const COLUMNS_ORDER = [
  { title: 'Lfd Nr.', width: 80, type: 'text', readOnly: true, field: 'Lfd_Nr' },
  { title: 'Datum', width: 100, type: 'text', readOnly: true, field: 'datum_formatted' },
  { title: 'Beginn', width: 80, type: 'text', readOnly: true, field: 'beginn' },
  { title: 'Ende', width: 80, type: 'text', readOnly: true, field: 'ende' },
  { title: 'Einsatzort', width: 150, type: 'text', readOnly: true, field: 'Einsatzort_Beschreibung' },
  { title: 'Einsatzstelle', width: 150, type: 'text', readOnly: true, field: 'Einsatzstelle_Beschreibung' },
  { title: 'Position', width: 80, type: 'text', readOnly: true, field: 'Pos' },
  { title: 'Mitarbeiter', width: 220, type: 'dropdown', autocomplete: true, field: 'Mitarbeiter', editable: true },
  { title: 'Angenommen', width: 90, type: 'text', readOnly: true, field: 'MA_gebucht', boolean: true },
  { title: 'Bestätigt', width: 90, type: 'text', readOnly: true, field: 'MA_bestätigt', boolean: true },
  { title: 'Check-In?', width: 100, type: 'checkbox', field: 'checkinRequired', editable: true, permission: 'internalDispo' },
  { title: 'Aktionen', width: 150, type: 'text', readOnly: true, field: '_aktionen', pinned: true }
];

// Billing mode (Abrechnungsansicht)
const COLUMNS_BILLING = [
  { title: 'Datum', width: 100, type: 'text', readOnly: true, field: 'datum_formatted' },
  { title: 'Beginn', width: 80, type: 'text', readOnly: true, field: 'beginn' },
  { title: 'Ende', width: 80, type: 'text', readOnly: true, field: 'ende' },
  { title: 'Stunden', width: 80, type: 'text', readOnly: true, field: 'hours' },
  { title: 'Strafen', width: 80, type: 'text', readOnly: true, field: 'Q' },
  { title: 'Einsatzort', width: 150, type: 'text', readOnly: true, field: 'Einsatzort_Beschreibung' },
  { title: 'Einsatzstelle', width: 150, type: 'text', readOnly: true, field: 'Einsatzstelle_Beschreibung' },
  { title: 'Position', width: 80, type: 'text', readOnly: true, field: 'Pos' },
  { title: 'Firma', width: 80, type: 'text', readOnly: true, field: 'Firmenkurzel' },
  { title: 'Mitarbeiter', width: 220, type: 'text', readOnly: true, field: 'Mitarbeiter' },
  { title: 'Angenommen', width: 90, type: 'text', readOnly: true, field: 'MA_gebucht', boolean: true },
  { title: 'Bestätigt', width: 90, type: 'text', readOnly: true, field: 'MA_bestätigt', boolean: true },
  { title: 'Zeit geprüft', width: 90, type: 'text', readOnly: true, field: 'Ist_Zeiten_geprüft', boolean: true },
  { title: 'Bezahlt', width: 90, type: 'text', readOnly: true, field: 'Bez', boolean: true },
  { title: 'Aktionen', width: 150, type: 'text', readOnly: true, field: '_aktionen', pinned: true }
];

export default {
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  name: "AdminjobsJSS",
  components: { ContactDetails, JobModal, Spinner, TopBanner, JssColumnManager },
  data() {
    return {
      token: "",
      filter: {
        project: "",
        start: new Date().toISOString().split("T")[0],
        end: in3Days.toISOString().split("T")[0],
        location: "",
        place: "",
        position: "",
        persnr: "",
        accepted: "",
        confirmed: "",
        time_checked: "",
        Bez: "",
        checkinRequired: ""
      },
      tableFilters: {},
      tableFilterTimer: null,
      printing: false,
      loading: false,
      bannerText: "",
      bannerMode: "success",
      allProjects: [],
      allUsers: [],
      contactDetails: false,
      showProjectDropdown: false,
      showActions: false,
      selectedJob: false,
      searched: false,
      jobs: [],
      billingMode: false,
      meta: {
        results: 0,
        sumBillableHours: 0,
        sumPenalties: 0,
      },
      stats: { permissions: {} },
      queryCount: 0,
      // jspreadsheet instance
      jssInstance: null,
      appendOnlyRowLoadingCleanup: null,
      sortState: null,
      gridClickHandler: null,
      connection: null,
      rowHighlighter: null,
      // Columns used at render time — stored to avoid index mismatches if
      // permissions change between render and event handlers
      renderedColumns: [],
      // Prevent recursive onchange when reverting
      revertingChange: false,
      // Unique locations/places derived from loaded jobs (for dependent dropdown filter)
      availableLocations: [],
      availablePlaces: [],
      // Per-user column order/visibility per view, loaded from the backend:
      // { [viewKey]: { order: [field...], hidden: [field...] } }
      viewSettings: {}
    };
  },
  computed: {
    today: function () {
      let d = new Date().toISOString().split("T")[0].split("-");
      return d[2] + "." + d[1] + "." + d[0];
    },
    datestamp: function () {
      return new Date().toISOString().split("T")[0];
    },
    // Persistence key for the current table view (order/billing mode)
    viewKey: function () {
      return "adminjobs-" + (this.billingMode ? "billing" : "order");
    },
    // All manageable columns of the current view (default order) for the
    // Spalten manager — the pinned Aktionen column is not listed.
    columnManagerColumns: function () {
      return this.getBaseColumns()
        .filter(col => !col.pinned)
        .map(col => ({ field: col.field, title: col.title }));
    },
    columnOrder: function () {
      const saved = this.viewSettings[this.viewKey];
      return (saved && saved.order) || [];
    },
    columnHidden: function () {
      const saved = this.viewSettings[this.viewKey];
      return (saved && saved.hidden) || [];
    }
  },
  methods: {
    // ═══════════════════════════════════════════════════════════════════
    // Function 1: resetFilter()
    // Resets all filter fields to defaults and reloads jobs.
    // Transformed 1:1 from old view.
    // ═══════════════════════════════════════════════════════════════════
    resetFilter() {
      this.filter = {
        project: "",
        start: new Date().toISOString().split("T")[0],
        end: in3Days.toISOString().split("T")[0],
        location: "",
        place: "",
        position: "",
        persnr: "",
        accepted: "",
        confirmed: "",
        time_checked: "",
        Bez: "",
        checkinRequired: ""
      };
      this.availableLocations = [];
      this.availablePlaces = [];
      this.tableFilters = {};
      this.getJobs();
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function 2: exportView()
    // Exports the current grid as .xlsx with the currently visible columns
    // in their rendered order (the pinned Aktionen column is excluded).
    // An active column filter inside the grid is honored via
    // worksheet.results.
    // ═══════════════════════════════════════════════════════════════════
    exportView() {
      const exportCols = this.renderedColumns.filter(col => col.field !== '_aktionen');
      const rows = this.jobs.map(job => exportCols.map(col => this.cellValueFor(job, col)));
      exportJssView({
        filename: new Date().toJSON().split("T")[0] + "_auftraege.xlsx",
        headers: exportCols.map(col => col.title),
        columnWidths: exportCols.map(col => col.width),
        rows: rows,
        worksheet: this.jssInstance && this.jssInstance[0]
      });
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: onColumnsChange({order, hidden})
    // Called by the Spalten manager — applies and persists the column
    // order/visibility for the current view.
    // ═══════════════════════════════════════════════════════════════════
    onColumnsChange({ order, hidden }) {
      this.viewSettings = Object.assign({}, this.viewSettings, {
        [this.viewKey]: { order: order, hidden: hidden }
      });
      CASP.saveViewSettings(this.viewKey, { order: order, hidden: hidden });
      this.renderGrid();
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function 3: checkClick(event)
    // Handles clicks on:
    //   - Modal background (closes actions modal)
    //   - Dropdown <p> items (project list, employee list)
    //   - Clicks outside inputs (closes dropdowns)
    // Transformed: project dropdown logic kept; employee dropdown is now
    // handled natively by jspreadsheet autocomplete. Grid action button
    // clicks are handled by handleGridClick().
    // ═══════════════════════════════════════════════════════════════════
    checkClick(event) {
      if (this.selectedJob) return;
      if (event.target == this.$refs.modalbg) {
        this.showActions = false;
      } else if (event.target.nodeName == "P") {
        if (
          event.target.innerText.includes("PSL") ||
          event.target.innerText.includes("SUB") ||
          event.target.innerText.includes("CSP") ||
          event.target.innerText == "Offen"
        ) {
          // Employee selection from dropdown (old style — kept for project list compat)
          this.filter.project = event.target.innerText;
        } else {
          // Project selection from dropdown
          this.filter.project = event.target.innerText;
        }
      }
      if (event.target.nodeName != "INPUT") {
        this.showProjectDropdown = false;
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function 4: changeCheckin(job)
    // Toggles the checkinRequired flag and saves via API.
    // Transformed: now triggered by jspreadsheet onchange event for the
    // checkbox column. The job object is found by row index.
    // ═══════════════════════════════════════════════════════════════════
    changeCheckin(job) {
      if (this.stats.permissions.internalDispo) {
        this.changeJob(job, { checkinRequired: job.checkinRequired });
      } else {
        job.checkinRequired = !job.checkinRequired;
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function 5: changeUser(job)
    // Saves employee assignment. Extracts Mitarbeiternr from displayName
    // and includes Firmenkurzel.
    // Called from JobModal @changeUser event — kept 1:1.
    // ═══════════════════════════════════════════════════════════════════
    changeUser(job) {
      this.selectedJob = false;
      let changes = { Mitarbeiternr: job.Mitarbeiter.split(" (")[0] };
      if (job.Firmenkurzel !== undefined) {
        changes.Firmenkurzel = job.Firmenkurzel;
      }
      this.changeJob(job, changes);
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function 6: changeJob(job, changes)
    // Generic API call to update a job. Reloads jobs on success.
    // Kept 1:1.
    // ═══════════════════════════════════════════════════════════════════
    changeJob(job, changes) {
      CASP.changeJob(this.token, job.id, changes, (res) => {
        if (res && res.status === "success") {
          this.rowHighlighter.mark(res.id || job.id);
          this.getJobs();
        } else if (res && res.error) {
          this.showBanner(res.error, "error");
          this.getJobs();
        }
      });
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function 7: getProjects()
    // Loads all projects for the project dropdown/autocomplete.
    // If only one project exists, auto-selects it and loads jobs.
    // Kept 1:1.
    // ═══════════════════════════════════════════════════════════════════
    getProjects() {
      let vm = this;
      CASP.getProjects(this.token, (res) => {
        if (res) {
          vm.allProjects = res;
          if (res.length == 1) {
            this.filter.project = res[0].name;
          }
        }
      });
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function 8: getUsers()
    // Loads all users for the employee autocomplete source.
    // Kept 1:1 — user display names populate the autocomplete column.
    // ═══════════════════════════════════════════════════════════════════
    getUsers() {
      let vm = this;
      CASP.getUsers(this.token, (res) => {
        if (res) {
          vm.allUsers = res;
        }
      });
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function 9: filterUsers(job)
    // OLD: Built HTML string of <p> elements for matching users, injected
    //      into a dropdown div.
    // NEW: Replaced by jspreadsheet's built-in autocomplete column type.
    //      The autocomplete source is set to all user display names, and
    //      the built-in filter handles typing-based filtering.
    // This function is kept as a no-op stub for compatibility — the
    // autocomplete column handles filtering natively.
    // ═══════════════════════════════════════════════════════════════════
    filterUsers(job) {
      // No-op: jspreadsheet autocomplete handles user filtering natively.
      // User display names are set as the column source in renderGrid().
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function 10: printPage()
    // Closes actions modal and triggers browser print after a short delay.
    // Kept 1:1.
    // ═══════════════════════════════════════════════════════════════════
    printPage() {
      this.showActions = false;
      setTimeout(() => { print(); }, 500);
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function 11: filterProjects()
    // Builds HTML of <p> elements for projects matching the typed text.
    // Injected into the project dropdown div.
    // Kept 1:1 — project filter is outside the grid, uses Vue dropdown.
    // ═══════════════════════════════════════════════════════════════════
    filterProjects() {
      this.showProjectDropdown = true;
      let options = "";
      this.allProjects.forEach((el) => {
        if (el.name.toLowerCase().includes(this.filter.project.toLowerCase())) {
          options += "<p class='dp'>" + el.name + "</p>";
        }
      });
      if (this.$refs.projectList) {
        this.$refs.projectList.innerHTML = options;
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function 12: requestSMS(type)
    // Sends SMS requests (confirm or accept) to employees matching filter.
    // Kept 1:1.
    // ═══════════════════════════════════════════════════════════════════
    requestSMS(type) {
      CASP.requestSMS(this.token,
        this.filter, type, (res) => {
          if (res.status == "success") {
            this.bannerText = res.amountSent + " SMS gesendet.";
            setTimeout(() => { this.bannerText = ""; }, 2000);
          } else if (res.error) {
            this.bannerText = res.error;
            this.bannerMode = "error";
            setTimeout(() => {
              this.bannerText = "";
              this.bannerMode = "success";
            }, 2000);
          }
        });
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function 13: getJobs(summarize)
    // Loads jobs from the server with the current filter.
    // OLD: Used a setTimeout-based progressive render loop to avoid Vue
    //      reactivity performance issues with large arrays.
    // NEW: jspreadsheet renders directly to DOM, so the full array is
    //      passed at once — no progressive rendering needed.
    // Also extracts unique locations/places from loaded data for the
    // dependent dropdown filter.
    // ═══════════════════════════════════════════════════════════════════
    getJobs(summarize = false) {
      clearTimeout(this.tableFilterTimer);
      this.tableFilterTimer = null;
      let vm = this;
      this.jobs = [];
      this.filter.summarize = summarize;
      this.loading = true;
      this.sendSocketFilter();
      const requestFilter = Object.assign({}, this.filter, { columnFilters: this.tableFilters });
      CASP.getAdminJobs(
        this.token,
        requestFilter,
        (res) => {
          vm.queryCount++;
          vm.meta = res.meta;
          vm.searched = true;
          vm.loading = false;
          vm.jobs = res.jobs || [];
          // Extract unique locations and places for dependent dropdown
          vm.extractFilterOptions();
          // Render the jspreadsheet grid with the loaded data
          vm.renderGrid();
          vm.rowHighlighter.apply();
        }
      );
    },

    sendSocketFilter() {
      if (!this.connection || this.connection.readyState !== WebSocket.OPEN) return;
      this.connection.send(JSON.stringify({
        type: "init",
        token: this.token,
        filter: Object.assign({}, this.filter, { columnFilters: this.tableFilters })
      }));
    },

    startSocket() {
      this.connection = new WebSocket(process.env.VUE_APP_WS_URL + '/updates');
      this.connection.onopen = () => this.sendSocketFilter();
      this.connection.onmessage = event => {
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (error) {
          return;
        }
        if (!data || !data.job || !['update', 'checkin'].includes(data.type)) return;
        const displayed = this.jobs.some(job => String(job.id) === String(data.job.id));
        if (!displayed) return;
        this.rowHighlighter.mark(data.job.id);
        this.getJobs();
      };
    },

    updateTableFilters(filters) {
      this.tableFilters = filters;
      clearTimeout(this.tableFilterTimer);
      this.tableFilterTimer = setTimeout(() => {
        this.tableFilterTimer = null;
        this.getJobs();
      }, 150);
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: extractFilterOptions()
    // Extracts unique Einsatzort and Einsatzstelle values from loaded jobs
    // to populate the dependent dropdown filter (filter column B depending
    // on value in column A).
    // ═══════════════════════════════════════════════════════════════════
    extractFilterOptions() {
      const locs = new Set();
      const placeMap = {}; // location -> Set of places
      this.jobs.forEach(job => {
        const loc = job.Einsatzort_Beschreibung;
        const place = job.Einsatzstelle_Beschreibung;
        if (loc) {
          locs.add(loc);
          if (!placeMap[loc]) placeMap[loc] = new Set();
          if (place) placeMap[loc].add(place);
        }
      });
      this.availableLocations = Array.from(locs).sort();
      this._placeMap = placeMap;
      // Update available places based on current location selection
      this.onEinsatzortChange();
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: onEinsatzortChange()
    // When Einsatzort filter changes, update Einsatzstelle options to only
    // show places that belong to the selected location.
    // This implements "filter column B depending on value in column A".
    // ═══════════════════════════════════════════════════════════════════
    onEinsatzortChange() {
      if (this.filter.location && this._placeMap && this._placeMap[this.filter.location]) {
        this.availablePlaces = Array.from(this._placeMap[this.filter.location]).sort();
      } else if (this._placeMap) {
        // No location selected: show all places
        const allPlaces = new Set();
        Object.values(this._placeMap).forEach(set => {
          set.forEach(p => allPlaces.add(p));
        });
        this.availablePlaces = Array.from(allPlaces).sort();
      } else {
        this.availablePlaces = [];
      }
      // Reset place filter if it's no longer valid
      if (this.filter.place && !this.availablePlaces.includes(this.filter.place)) {
        this.filter.place = "";
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: toggleBillingMode()
    // Switches between Auftragsübersicht and Abrechnungsansicht.
    // Re-renders the grid with the appropriate column set.
    // ═══════════════════════════════════════════════════════════════════
    toggleBillingMode() {
      this.billingMode = !this.billingMode;
      this.renderGrid();
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: getBaseColumns()
    // Returns the column definition array for the current billing mode.
    // Filters out columns that require permissions the user doesn't have.
    // ═══════════════════════════════════════════════════════════════════
    getBaseColumns() {
      const cols = this.billingMode ? COLUMNS_BILLING : COLUMNS_ORDER;
      return cols.filter(col => {
        if (col.permission && !this.stats.permissions[col.permission]) {
          return false;
        }
        return true;
      });
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: getColumns()
    // Base columns with the user's saved order/visibility applied.
    // ═══════════════════════════════════════════════════════════════════
    getColumns() {
      return applyColumnSettings(this.getBaseColumns(), this.viewSettings[this.viewKey]);
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: buildRowData(job, cols)
    // Maps a job object to a row array matching the given column defs.
    // Handles boolean-to-icon conversion and computed fields (beginn/ende).
    // ═══════════════════════════════════════════════════════════════════
    buildRowData(job, cols) {
      return cols.map(col => this.cellValueFor(job, col));
    },

    // NEW: cellValueFor(job, col)
    // Maps a single job field to its grid cell value.
    cellValueFor(job, col) {
      // Computed fields
      if (col.field === 'beginn') {
        return job['Ist_Zeiten_geprüft'] ? job.Von_Uhrzeit : job.Soll_Von;
      }
      if (col.field === 'ende') {
        return job['Ist_Zeiten_geprüft'] ? job.Bis_Uhrzeit : job.Soll_Bis;
      }
      if (col.field === '_aktionen') {
        return 'Details';
      }
      // Checkbox columns → actual boolean values (jspreadsheet expects booleans, not strings)
      if (col.type === 'checkbox') {
        const val = job[col.field];
        return val === true || val === 1 || val === 'true';
      }
      // Boolean display fields → display text
      if (col.boolean) {
        const val = job[col.field];
        if (val === true || val === 'true' || val === 1) return '✓';
        if (val === false || val === 'false' || val === 0 || val === '') return '✗';
        return String(val);
      }
      // Default
      return job[col.field] !== undefined && job[col.field] !== null ? String(job[col.field]) : '';
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: renderGrid()
    // Creates/destroys the jspreadsheet instance with current data and
    // column definitions. Wires up all event handlers:
    //   - onchange: cell edits (employee, checkin)
    //   - oncreatecell: custom rendering for status icons and action buttons
    //   - onclick: shift+click to copy, action button clicks
    //   - onbeforechange: prevent editing past jobs' employee field
    // ═══════════════════════════════════════════════════════════════════
    renderGrid() {
      const container = this.$refs.spreadsheetContainer;
      if (!container) return;
      removeAutocompleteFilters(container);

      // Destroy existing instance
      if (this.appendOnlyRowLoadingCleanup) {
        this.appendOnlyRowLoadingCleanup();
        this.appendOnlyRowLoadingCleanup = null;
      }
      if (this.gridClickHandler) {
        container.removeEventListener('click', this.gridClickHandler);
        this.gridClickHandler = null;
      }
      if (container.spreadsheet) {
        try { jspreadsheet.destroy(container); } catch (e) { /* ignore */ }
      }
      container.innerHTML = '';
      this.jssInstance = null;

      if (this.jobs.length === 0) {
        container.innerHTML = '<div class="text-gray-500 p-8 text-center font-bold">Keine Aufträge gefunden.</div>';
        return;
      }

      const cols = this.getColumns();
      // Store the columns used at render time so event handlers use the
      // same column mapping (avoids index mismatches if permissions change)
      this.renderedColumns = cols;
      if (this.sortState) {
        const sortColumn = cols.find(col => col.field === this.sortState.field);
        if (sortColumn) {
          this.jobs = sortJssRows(
            this.jobs,
            job => this.cellValueFor(job, sortColumn),
            this.sortState.direction
          );
        }
      }
      const data = this.jobs.map(job => this.buildRowData(job, cols));

      // Build column config for jspreadsheet
      const columns = cols.map(col => {
        const colDef = {
          title: col.title,
          width: col.width,
          type: col.type
        };
        if (col.readOnly) colDef.readOnly = true;
        // Dropdown with autocomplete: set source to all user display names
        if (col.type === 'dropdown' && col.autocomplete && col.field === 'Mitarbeiter') {
          colDef.source = this.allUsers.map(u => ({
            id: u.displayName,
            name: u.displayName,
            tooltip: u.pendingApproval ? 'Freigabe durch internen Admin ausstehend' : '',
            disabled: u.pendingApproval === true
          }));
          colDef.autocomplete = true;
          colDef.multiple = false;
        }
        return colDef;
      });

      const vm = this;

      this.jssInstance = jspreadsheet(container, {
        onchange: (instance, cell, colIndex, rowIndex, newValue, oldValue) => {
          vm.handleCellChange(colIndex, rowIndex, newValue, oldValue);
        },
        onbeforechange: (instance, cell, colIndex, rowIndex, newValue) => {
          // Prevent editing employee column for past jobs in non-billing mode
          if (vm.revertingChange) return undefined;
          const col = vm.renderedColumns[colIndex];
          if (col && col.field === 'Mitarbeiter' && !vm.billingMode) {
            const job = vm.jobs[rowIndex];
            if (job && job.Datum_von < vm.datestamp) {
              vm.showBanner('Mitarbeiter kann nicht geändert werden (Termin in der Vergangenheit)', 'error');
              return false;
            }
          }
          return undefined;
        },
        oncreatecell: (instance, cell, colIndex, rowIndex, newValue) => {
          vm.handleCreateCell(instance, cell, colIndex, rowIndex, newValue);
        },
        oncopy: (instance, selectedRange, copiedData, cut) => {
          // Hook into copy events — can modify copied data if needed
          return undefined;
        },
        onsort: (instance, colIndex, order, newOrder) => {
          const column = vm.renderedColumns[colIndex];
          if (!column || column.field === "_aktionen") return;
          vm.sortState = {
            field: column.field,
            direction: order === 1 ? "desc" : "asc"
          };
          vm.renderGrid();
        },
        worksheets: [{
          data: data.slice(0, 100),
          columns: columns,
          filters: true,
          tableOverflow: true,
          tableHeight: 'calc(100vh - 380px)',
          tableWidth: '100%',
          columnSorting: true,
          lazyLoading: true,
          defaultColAlign: 'left',
          wordWrap: true
        }]
      });
      const worksheet = this.jssInstance[0];
      this.appendOnlyRowLoadingCleanup = installAppendOnlyRowLoading(worksheet, {
        remainingRows: data.slice(100),
        appendRows: rows => rows.forEach(row => worksheet.insertRow(
          row,
          worksheet.rows.length - 1,
          false
        ))
      });
      // Keep the filter row below the sticky title row instead of
      // overlapping it (both would stick at top:0 otherwise).
      stickFilterRow(container);
      installAutocompleteFilters(container, this.jssInstance[0], this.renderedColumns, {
        initialFilters: this.tableFilters,
        onFilterChange: filters => this.updateTableFilters(filters)
      });

      // ─── Container-level click handler ───────────────────────────
      // Handles:
      //   1. Column filter icon single-click → open filter dropdown
      //   2. Shift+click → copy cell value to clipboard
      //   3. Click on "Details" button → open JobModal
      //   4. Click on "Kontakt" button → open ContactDetails
      //   5. Single-click on dropdown/checkbox cells → open editor
      this.gridClickHandler = (e) => {
        const ws = vm.jssInstance && vm.jssInstance[0];
        if (!ws) return;

        // ── Column filter: open on single click (CE defaults to double-click) ──
        if (e.target.classList.contains('jss_column_filter')) {
          const colIndex = e.target.getAttribute('data-x');
          if (colIndex !== null) {
            ws.openFilter(parseInt(colIndex));
          }
          return;
        }

        // ── Shift+click to copy cell value to clipboard ──
        if (e.shiftKey) {
          const cell = e.target.closest('td[data-x][data-y]');
          if (cell) {
            const colIndex = parseInt(cell.getAttribute('data-x'));
            const rowIndex = parseInt(cell.getAttribute('data-y'));
            const value = ws.getValueFromCoords(colIndex, rowIndex);
            if (value !== '' && value !== null && value !== undefined) {
              navigator.clipboard.writeText(String(value)).then(() => {
                vm.showBanner('Wert kopiert: ' + String(value).substring(0, 30), 'success');
              }).catch(() => {
                // Fallback for browsers without clipboard API
                const textarea = document.createElement('textarea');
                textarea.value = String(value);
                document.body.appendChild(textarea);
                textarea.select();
                try { document.execCommand('copy'); } catch (err) { /* ignore */ }
                document.body.removeChild(textarea);
                vm.showBanner('Wert kopiert', 'success');
              });
            }
            e.preventDefault();
            return;
          }
        }

        // ── Action button clicks (Details / Kontakt) ──
        if (e.target.classList.contains('jss-btn-details') || e.target.closest('.jss-btn-details')) {
          const cell = e.target.closest('td[data-x][data-y]');
          if (cell) {
            const rowIndex = parseInt(cell.getAttribute('data-y'));
            const job = vm.jobs[rowIndex];
            if (job) {
              vm.selectedJob = job;
            }
          }
          e.stopPropagation();
          return;
        }
        if (e.target.classList.contains('jss-btn-kontakt') || e.target.closest('.jss-btn-kontakt')) {
          const cell = e.target.closest('td[data-x][data-y]');
          if (cell) {
            const rowIndex = parseInt(cell.getAttribute('data-y'));
            const job = vm.jobs[rowIndex];
            if (job) {
              vm.contactDetails = job;
            }
          }
          e.stopPropagation();
          return;
        }

        // ── Single-click on dropdown cells to open editor ──
        // Note: checkbox cells are NOT included here. jspreadsheet's native
        // checkbox onclick handler already toggles the value. Calling
        // openEditor for checkboxes causes a double-toggle (openEditor
        // toggles once, then the native onclick toggles back).
        const cell = e.target.closest('td[data-x][data-y]');
        if (cell && cell.classList.contains('highlight') && !ws.edition) {
          const colIndex = parseInt(cell.getAttribute('data-x'));
          const col = vm.renderedColumns[colIndex];
          if (col && col.type === 'dropdown') {
            if (!col.readOnly) {
              // Check if employee column and past job — don't open editor
              if (col.field === 'Mitarbeiter' && !vm.billingMode) {
                const rowIndex = parseInt(cell.getAttribute('data-y'));
                const job = vm.jobs[rowIndex];
                if (job && job.Datum_von < vm.datestamp) return;
              }
              ws.openEditor(cell, undefined, e);
            }
          }
        }
      };
      container.addEventListener('click', this.gridClickHandler);
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: handleCreateCell(instance, cell, colIndex, rowIndex, newValue)
    // Custom cell rendering via oncreatecell event:
    //   - Boolean status columns → green ✓ / red ✗ with styling
    //   - Aktionen column → "Details" and optionally "Kontakt" buttons
    //   - Employee column for past jobs → grayed out styling
    // ═══════════════════════════════════════════════════════════════════
    handleCreateCell(instance, cell, colIndex, rowIndex, newValue) {
      const col = this.renderedColumns[colIndex];
      if (!col) return;

      // Skip custom rendering for checkbox cells — jspreadsheet renders its own checkbox
      if (col.type === 'checkbox') return;

      // Boolean status columns → colored icons
      if (col.boolean) {
        if (newValue === '✓') {
          cell.innerHTML = '<span style="color:#22C55E;font-weight:bold;font-size:1.2em">✓</span>';
        } else if (newValue === '✗') {
          cell.innerHTML = '<span style="color:#ef4444;font-weight:bold;font-size:1.2em">✗</span>';
        }
        return;
      }

      // Aktionen column → action buttons
      if (col.field === '_aktionen') {
        cell.classList.add('jss-nowrap');
        const job = this.jobs[rowIndex];
        if (!job) return;
        // Look & feel comes from the .admin-shell .jss-btn-* rules in
        // admin.css + the scoped :deep() rules below — no inline styles.
        let html = '<button type="button" class="admin-button--secondary admin-button--sm jss-btn-details">Details</button>';
        // Show Kontakt button for jobs with employee and time not checked (non-billing only)
        if (!this.billingMode && job.Mitarbeiter && !job['Ist_Zeiten_geprüft']) {
          html += ' <button type="button" class="admin-button--secondary admin-button--sm jss-btn-kontakt">Kontakt</button>';
        }
        cell.innerHTML = html;
        return;
      }

      // Employee column for past jobs → grayed out (non-billing mode)
      if (col.field === 'Mitarbeiter' && !this.billingMode) {
        const job = this.jobs[rowIndex];
        if (job && job.Datum_von < this.datestamp) {
          cell.style.color = '#9ca3af';
          cell.style.fontStyle = 'italic';
        }
        // Highlight employees without documents
        if (job && job.ma_data && !job.ma_data.hasDocuments) {
          cell.style.backgroundColor = '#fecaca';
        }
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: handleCellChange(colIndex, rowIndex, newValue, oldValue)
    // Central cell change handler — replaces the old per-element @change
    // handlers. Dispatches to the appropriate save logic based on column.
    //   - Mitarbeiter column → changeUser logic (extract persnr, save)
    //   - checkinRequired column → changeCheckin logic (save toggle)
    // ═══════════════════════════════════════════════════════════════════
    handleCellChange(colIndex, rowIndex, newValue, oldValue) {
      // Skip if reverting a blocked change
      if (this.revertingChange) {
        this.revertingChange = false;
        return;
      }
      if (newValue === oldValue) return;

      const col = this.renderedColumns[colIndex];
      if (!col) return;

      const job = this.jobs[rowIndex];
      if (!job) return;

      // ── Mitarbeiter (employee) column changed ──
      if (col.field === 'Mitarbeiter' && !this.billingMode) {
        // Prevent changes to past jobs
        if (job.Datum_von < this.datestamp) {
          this.revertingChange = true;
          const ws = this.jssInstance && this.jssInstance[0];
          if (ws) ws.setValueFromCoords(colIndex, rowIndex, oldValue);
          this.showBanner('Mitarbeiter kann nicht geändert werden (Termin in der Vergangenheit)', 'error');
          return;
        }

        // Reject employees awaiting internal approval
        const pendingPersnr = newValue.split(" (")[0];
        const pendingUser = this.allUsers.find(u => u.persnr == pendingPersnr);
        if (pendingUser && pendingUser.pendingApproval) {
          this.revertingChange = true;
          const wsPending = this.jssInstance && this.jssInstance[0];
          if (wsPending) wsPending.setValueFromCoords(colIndex, rowIndex, oldValue);
          this.showBanner('Mitarbeiter wartet auf Freigabe durch einen internen Admin', 'error');
          return;
        }

        // Update local job data
        job.Mitarbeiter = newValue;

        // Extract persnr from displayName (format: "persnr (name surname)")
        const persnr = newValue.split(" (")[0];
        const changes = { Mitarbeiternr: persnr };

        // Override Firmenkurzel with the selected employee's Firmenkurzel
        const selectedUser = this.allUsers.find(u => u.persnr == persnr);
        if (selectedUser && selectedUser.Firmenkurzel) {
          job.Firmenkurzel = selectedUser.Firmenkurzel;
          changes.Firmenkurzel = selectedUser.Firmenkurzel;
        }

        // Save via API
        this.changeJob(job, changes);
        return;
      }

      // ── checkinRequired column changed ──
      if (col.field === 'checkinRequired') {
        job.checkinRequired = newValue;
        this.changeCheckin(job);
        return;
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: showBanner(text, mode)
    // Helper to show a temporary banner notification.
    // ═══════════════════════════════════════════════════════════════════
    showBanner(text, mode = 'success') {
      this.bannerText = text;
      this.bannerMode = mode;
      setTimeout(() => { this.bannerText = ''; }, 3000);
    }
  },

  // ═══════════════════════════════════════════════════════════════════
  // Lifecycle: mounted
  // Auth check → load projects, users, jobs, stats.
  // Kept 1:1 from old view.
  // ═══════════════════════════════════════════════════════════════════
  mounted: function () {
    let vm = this;
    document.getElementById("mainspinner").style.display = "none";
    CASP.isAuthenticated(this.token, (auth) => {
      if (!auth) {
        window.location = "/admin/login";
      } else {
        this.getProjects();
        this.getUsers();
        this.rowHighlighter = createRowHighlighter({
          getContainer: () => this.$refs.spreadsheetContainer,
          getRows: () => this.jobs
        });
        this.startSocket();
        CASP.getViewSettings((status, res) => {
          if (status === 200 && res) {
            vm.viewSettings = res;
            if (vm.jssInstance) vm.renderGrid();
          }
        });
        this.getJobs();
        CASP.getStats((status, response) => {
          if (status == 200) {
            vm.stats = response;
            // Re-render grid now that permissions are available — the
            // checkin column is permission-gated and may not have been
            // rendered on the first renderGrid() call from getJobs().
            if (vm.jobs.length > 0) {
              vm.renderGrid();
            }
          }
        });
      }
    });
  },

  // ═══════════════════════════════════════════════════════════════════
  // Lifecycle: beforeUnmount
  // Clean up jspreadsheet instance and event listeners.
  // ═══════════════════════════════════════════════════════════════════
  beforeUnmount() {
    clearTimeout(this.tableFilterTimer);
    if (this.rowHighlighter) this.rowHighlighter.clear();
    if (this.appendOnlyRowLoadingCleanup) {
      this.appendOnlyRowLoadingCleanup();
      this.appendOnlyRowLoadingCleanup = null;
    }
    if (this.connection) {
      try { this.connection.close(); } catch (e) { /* ignore */ }
    }
    const container = this.$refs.spreadsheetContainer;
    if (container) {
      removeAutocompleteFilters(container);
      if (this.gridClickHandler) {
        container.removeEventListener('click', this.gridClickHandler);
      }
      if (container.spreadsheet) {
        try { jspreadsheet.destroy(container); } catch (e) { /* ignore */ }
      }
      container.innerHTML = '';
    }
  }
};
</script>

<style scoped>
/* jspreadsheet-ce v5 assigns its visual arrows opposite to the sort
   direction used by its context-menu actions. */
.jss-container :deep(.jss_worksheet > thead > tr > td.arrow-up) {
  background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3Cpath d='M7 10l5 5 5-5H7z' fill='gray'/%3E%3C/svg%3E");
}

.jss-container :deep(.jss_worksheet > thead > tr > td.arrow-down) {
  background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3Cpath d='M7 14l5-5 5 5H7z' fill='gray'/%3E%3C/svg%3E");
}

#printtest {
  display: none;
}

.jss-container {
  width: 100%;
  overflow: visible;
  text-align: left;
}

/* Header text black, left-aligned like the data cells */
.jss-container :deep(.jss_worksheet > thead > tr > td) {
  color: #000 !important;
  text-align: left;
}

/* All data fields left-aligned (the container's text-align would
   otherwise be inherited into the cells) */
.jss-container :deep(.jss_worksheet > tbody > tr > td) {
  text-align: left;
}

/* All items left-aligned, including the row-number column */
.jss-container :deep(.jss_worksheet > tbody > tr > td:first-child) {
  text-align: left;
}

/* Aktionen cells must never line-break. jspreadsheet keeps applying
   inline white-space:pre-wrap (wordWrap option and >200-char content),
   so !important is required; the class is re-added on every cell render. */
.jss-container :deep(.jss_worksheet td.jss-nowrap) {
  white-space: nowrap !important;
}

/* Override global tailwind.css checkbox hiding inside the grid.
   The global [type="checkbox"] rule uses appearance-none + w-0 and relies
   on a label::before pseudo-element, but jspreadsheet creates bare
   <input type="checkbox"> without a label, making them invisible. */
.jss-container :deep(.jss_worksheet input[type="checkbox"]) {
  appearance: auto;
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin: 0;
}

/* Ensure thead stays sticky inside the scrollable .jss_content container */
.jss-container :deep(.jss_content) {
  overflow: auto;
}

.jss-container :deep(.jss_worksheet > thead > tr > td) {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: #f3f4f6;
}

/* The filter row is a second thead row (its cells carry the class
   jss_column_filter) — without an offset it would stick at top:0
   directly on top of the title row and hide it on scroll.
   --jss-header-h is set by stickFilterRow() after each render. */
.jss-container :deep(.jss_worksheet > thead > tr.jss-filter-row > td) {
  top: var(--jss-header-h, 26px);
}

/* Neutral gray for selected/highlighted cells */
.jss-container :deep(.jss_worksheet .highlight),
.jss-container :deep(.jss_worksheet td.highlight),
.jss-container :deep(.jss_worksheet .highlight-selected),
.jss-container :deep(.jss_worksheet .selection),
.jss-container :deep(.jss_worksheet tr.selected > td) {
  background-color: #e5e7eb !important;
}

.jss-container :deep(.jss_worksheet > tbody > tr.selected > td:first-child) {
  background-color: #d1d5db !important;
}

/* Action buttons in grid cells — base colors come from the
   .admin-shell .jss-btn-* rules in admin.css; keep them compact here. */
.jss-container :deep(.jss-btn-details),
.jss-container :deep(.jss-btn-kontakt) {
  min-height: 0;
  padding: 2px 8px;
  font-size: 12px;
  line-height: 1.4;
  margin: 1px;
  white-space: nowrap;
  cursor: pointer;
}

.jss-container :deep(.jss-btn-details:hover),
.jss-container :deep(.jss-btn-kontakt:hover) {
  background-color: #edf0f4 !important;
}

tr {
  page-break-inside: avoid;
  line-height: 1;
}

@media print {
  #printtest {
    display: none;
  }

  button {
    display: none;
  }

  .jss-container {
    overflow: visible !important;
  }
}
</style>
